import { faro, getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'
import { envVariables, isProd } from './env-variables'

// mirrors plc-app's faro setup (web/instrumentation-client.js) and reports to the same collector,
// under its own app name so the overlay can be filtered apart from plc-web and the native app
const FARO_APP_NAME = 'plc-twitch-embed'

// a source string so the positive and negative host patterns can't drift, same as plc-app's faro-ignore-urls.ts
const PL_HOST_SOURCE = 'https:\\/\\/([a-z0-9-]+\\.)*playerslounge\\.(co|com)(\\/|$)'
const PL_HOSTS = new RegExp(`^${PL_HOST_SOURCE}`, 'i')
// third party traffic gets no trace headers so there's nothing to learn from instrumenting it
const THIRD_PARTY = new RegExp(`^(?!${PL_HOST_SOURCE})`, 'i')
// faro's http instrumentation traces its own posts to the collector otherwise, which loops forever
const COLLECTOR = /\/collect(\/|$)/
const FARO_IGNORE_URLS = [THIRD_PARTY, COLLECTOR]

export const initFaro = () => {
  // plc-app's collector drops non production traffic anyway, so don't bother sending from local dev
  if (process.env.NODE_ENV !== 'production' || !envVariables.FARO_COLLECTOR_URL) return

  initializeFaro({
    url: envVariables.FARO_COLLECTOR_URL,
    app: {
      name: FARO_APP_NAME,
      version: process.env.REACT_APP_PL_VERSION,
      environment: isProd ? 'prod' : 'dev',
    },
    // the web tracing instrumentation reads this too, so one list covers both
    ignoreUrls: FARO_IGNORE_URLS,
    instrumentations: [
      // the overlay logger sends structured logs to faro itself, capturing the console too would double every line
      ...getWebInstrumentations({ captureConsole: false }),
      new TracingInstrumentation({
        instrumentationOptions: {
          // pl-connect allow-lists traceparent/tracestate, other hosts would fail the cors preflight
          propagateTraceHeaderCorsUrls: [PL_HOSTS],
        },
      }),
    ],
    sessionTracking: {
      enabled: true,
      // sampling drops every signal for unsampled sessions, keep them all like plc-app does
      samplingRate: 1,
    },
  })
}

// the overlay is per streamer, so tag sessions with whose overlay it is
export const setFaroUser = (userId: string | null) => {
  if (userId) faro.api?.setUser({ id: userId })
  else faro.api?.resetUser()
}

